<!--
/*
* @component 填写订房信息组件
* @author tyler
* doing
* */
-->

<template>

  <div class="booking">

    <div class="block">
      <div class="block-head">
        {{$t('Details')}}
      </div>
      <div class="room-nav">
        <ul>
          <li
            v-for="(room,key,index) of roomOrigin"
            :key="index"
            :class="{'active':index===roomIndex-1}"
          >
            {{$t('Room')}}{{key.split('_')[1]}}
          </li>
        </ul>
      </div>
      <div class="block-content">
        <el-form
          :model="editInfo"
          :rules="rules"
          ref="informationForm">
          <div class="form-row">
            <div class="room-info">
              <ul>
                <li>
                  <label>{{$t('Arrival Date')}}:</label>
                  <span>{{roomPubInfo.Arrival_Date | dateFormat(that)}}</span>
                </li>
                <li>
                  <label>{{$t('Departure Date')}}:</label>
                  <span>{{roomPubInfo.Departure_date | dateFormat(that)}}</span>
                </li>
                <li>
                  <label>{{$t('Adults Per Room')}}:</label>
                  <span>{{roomPubInfo.Adults_per}}</span>
                </li>
                <li>
                  <label>{{$t('Child Per Room')}}:</label>
                  <span>{{roomPubInfo.Child_per}}</span>
                </li>
                <li>
                  <label>{{$t('Hotel')}}:</label>
                  <span>{{editInfo.Hotel_code.name}}</span>
                </li>
                <li>
                  <label>{{$t('Room Type')}}:</label>
                  <span>{{editInfo.Roomtype_code.name}}</span>
                </li>
                <li>
                  <label>{{$t('Rate Code')}}:</label>
                  <span>{{editInfo.Rate_code.name}}</span>
                </li>
              </ul>
              <el-button
                class="secondry action-remove"
                @click.prevent="remove">
                {{$t('Remove')}}
              </el-button>
            </div>
          </div>
          <div class="form-row">

            <el-form-item
              :label="$t('Same As Default')+':'"
              class="same-as"
              v-if="roomIndex!==1"
              prop="sameAs">

              <el-select
                :placeholder="$t('Select')"
                v-model="sameAs"
                @change="sameAsConfig(sameAs)"
                name="">
                <el-option
                  v-for="(room,key,index) of roomSave"
                  :label="key.replace('_','')"
                  :value="key"
                  :key="index"/>
              </el-select>

            </el-form-item>

            <el-form-item
              :label="$t('Title')+':'"
              prop="Title"
              :rules="{ required: true, message: $t('Please choose your title')}">

              <el-select
                v-model="editInfo.Title"
                :placeholder="$t('Please select an option')">
                <el-option
                  v-for="(title,index) of titles"
                  :label="title.Name"
                  :value='`{"name":"${title.Name}","code":"${title.Code}"}`'
                  :key="index"/>
              </el-select>
            </el-form-item>

            <el-form-item
              :label="$t('First Name')+':'"
              prop="Firstname"
              :rules="{ required: true, message: $t('Please insert guest\'s first name')}">

              <el-input v-model="editInfo.Firstname"/>
            </el-form-item>
            <el-form-item
              :label="$t('Last Name')+':'"
              prop="Lastname"
              :rules="{ required: true, message: $t('Please insert guest\'s last name')}">
              <el-input v-model="editInfo.Lastname"/>
            </el-form-item>
            <el-form-item
              :label="$t('Place of Residence')+':'"
              prop="CountryCode"
              :rules="{ required: true, message: $t('Please choose your place of residence')}">
              <el-select
                v-model="editInfo.CountryCode"
                filterable
                :placeholder="$t('Please select an option')">
                <el-option
                  v-for="(country,index) of countries"
                  :label="country.name"
                  :value='`{"name":"${country.name}","code":"${country.code}"}`'
                  :key="index"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('Phone Number')+':'"
              prop="Phone"
              :rules="[{ required: true, message: $t('Please insert phone number')},
              {type: 'number',message:$t('Phone number must be number')}]">
              <el-input v-model.number="editInfo.Phone"/>
            </el-form-item>
            <el-form-item
              :label="$t('Email Address')+':'"
              class="email-notification"
              prop="Email"
              :rules="[{ type: 'email',message:$t('Please insert correct email format') },
                  { required:true,message: $t('Please insert correct email format')}]">
              <el-input v-model="editInfo.Email"/>
            </el-form-item>
            <el-form-item class="email-notification" label=" ">
              <el-checkbox
                :label="$t('Email Notification')"
                true-label="1"
                false-label="0"
                v-model="editInfo.Email_confirm"
                name="Email_confirm"
              />
            </el-form-item>
            <el-form-item
              :label="$t('Patron ID')+':'"
              prop="PatronId">
              <el-input v-model="editInfo.PatronId"/>
            </el-form-item>

            <el-form-item
              v-if="0"
              :label="$t('Post')+':'"
              prop="POST">
              <el-radio-group v-model="editInfo.POST">
                <el-radio label="1">{{$t('Yes')}}</el-radio>
                <el-radio label="0">{{$t('No')}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              :label="$t('Special Request: (optional)')"
              class="special-request"
              prop="Special_codes">
              <el-checkbox-group
                class="el-checkbox-group"
                v-model="editInfo.Special_codes">
                <el-checkbox
                  v-for="(special,index) of specials"
                  :label="special.code"
                  :key="index"
                  name="Special_codes"
                >
                  {{special.name}}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label=" " prop="Comments">
              <el-input
                v-model="editInfo.Comments"
                type="textarea"
                :placeholder="$t('Click to enter Additional information')"/>
            </el-form-item>

          </div>
        </el-form>
      </div>
    </div>
    <div class="button-set">
      <button
        class="primary previous"
        @click="navChange(roomIndex-1)"
        v-if="roomIndex!==1">
        {{$t('Previous Room')}}
      </button>
      <button
        class="primary next"
        @click="nextRoom"
        v-if="roomIndex!==roomQty">
        {{$t('Next Room')}}
      </button>
      <button
        class="primary action-submit"
        @click="submit"
        v-else>
        {{$t('Submit')}}
      </button>
    </div>


  </div>

</template>

<script>

  export default {
    props: [],
    data: function () {

      const checkID = (rule, value, callback) => {
        if (value && /\D/.test(value)) {
          callback(new Error(this.$t('Patron ID must be number')));
        } else {
          callback();
        }
      };


      return {
        editInfo: {
          Hotel_code: {
            code: '',
            name: ''
          },
          Roomtype_code: {
            code: '',
            name: ''
          },
          Rate_code: {
            code: '',
            name: ''
          },
          CountryCode: '',
          Title: '',
          Firstname: '',
          Lastname: '',
          Phone: '',
          Email: '',
          Email_confirm: '1',
          Comments: '',
          Special_codes: [],
          PatronId: '',
          // POST: '0',

        },
        rules: {
          Firstname: [
            {required: true, trigger: ['blur', 'change']},
          ],
          Lastname: [
            {required: true, trigger: ['blur', 'change']},
          ],
          Phone: [
            {required: true, trigger: ['blur', 'change']},
            {type: 'number', trigger: ['blur', 'change']},
          ],
          Email: [
            {required: true, trigger: ['blur', 'change']},
            {type: 'email', trigger: ['blur', 'change']}
          ],
          PatronId: [
            {validator: checkID}
          ]
        },
        countries: [],
        titles: [],
        specials: [],
        roomSave: {},
        roomIndex: 1,
        sameAs: '',

        config: {
          autoSave: false,
          disableNav: false
        }
      }
    },
    methods: {

      /*
      * @method { Function } initData 初始化room数据
      * @param { String } key room源的key
      * */
      initData(key) {
        Object.assign(this.editInfo, this.roomOrigin[key])
        this.getInfos('/api/junket/info/specials', 'specials', 'specials', {
          params: {'hotel-code': this.roomOrigin[key]?.Hotel_code.code}
        })
      },

      /*
      * @method { Function } getInfos 获取信息通用方法
      * @param { String } url 请求地址
      * @param { String } dataKey 本地属性名
      * @param { String } resKey 远程属性名
      * @param { Object } data 请求配置信息
      * */
      getInfos(url, dataKey, resKey, data = {}) {
        this.axios.get(url, data)
          .then((res) => {
              if (res.code === 200) {
                this[dataKey] = res.data[resKey]
              }
            }
          )
      },

      /*
      * @method { Function } nextRoom 保存当前房间信息并填写下个房间
      * */
      nextRoom() {
        this.$refs.informationForm.validate((valid) => {
          if (valid) {
            this.saveRoom()
            this.roomIndex++
            this.navChange(this.roomIndex)
          } else {
            return false;
          }
        });
      },

      /*
      * @method { Function } navChange 切换房间标签
      * @param { String } index 房间索引(1开始)
      * */
      navChange(index) {
        this.roomIndex = index
        this.sameAs = ''
        this.initData(this.roomKey[0])
        this.getSaveConfig(this.roomKey[0])
      },

      /*
      * @method { Function } saveRoom 保存房间信息到vuex
      * @param { String } index 房间索引
      * */
      saveRoom() {
        let obj = {}
        Object.assign(obj, this.editInfo,
          {
            'CountryCode': JSON.parse(this.editInfo.CountryCode),
            'Title': JSON.parse(this.editInfo.Title)
          })
        this.$set(this.roomSave, this.roomKey[0], obj)
      },


      /*
      * @method { Function } submit 提交订房信息
      * */
      submit() {
        this.$refs.informationForm.validate((valid) => {
          if (valid) {
            this.saveRoom()
            let data = {
              Arrival: this.roomPubInfo.Arrival_Date,
              Departure: this.roomPubInfo.Departure_date,
              Adults: this.roomPubInfo.Adults_per,
              Children: this.roomPubInfo.Child_per,
              Info: this.roomSaveArr
            }
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.axios.post('/api/junket/order', data).then((res) => {
                if (res.code === 200) {
                  this.$message.success(res.msg);
                  this.$store.commit('stateChange', {k: 'orderConfirmation', v: res.data})
                  this.$router.push({path: '/confirmation'});
                } else {
                  this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'error'
                  });
                }
              }
            ).finally(function () {
              loading.close();
            })
          } else {
            return false;
          }
        });
      },

      /*
      * @method { Function } remove 删除当前房间
      * */
      remove() {
        /*
        * 1.删除保存的编辑信息
        * 2.删除数据源
        * 3.删除成功后更新新的房间索引信息,当前索引大于房间数量时显示前一间房
        * */
        this.$delete(this.roomSave, this.roomKey[0])
        let newRoomOrigin = Object.assign({}, this.roomOrigin)
        this.$delete(newRoomOrigin, this.roomKey[0])
        this.$store.commit('stateChange', {k: 'roomOrigin', v: newRoomOrigin})
        if (this.roomIndex > this.roomQty) {
          this.roomIndex = this.roomQty
        }
        if (this.roomIndex) {
          this.navChange(this.roomIndex)
        }
      },

      /*
      * @method { Function } getSaveConfig 获取已保存的订房信息
      * @param { String } key 目标房间信息的key
      * */
      getSaveConfig(key) {
        if (this.roomSave[key]) {
          let obj = Object.assign({}, this.roomSave[key]);
          obj.CountryCode = JSON.stringify(obj.CountryCode);
          obj.Title = JSON.stringify(obj.Title);
          delete obj.Hotel_code
          delete obj.Rate_code
          delete obj.Roomtype_code
          this.editInfo = Object.assign(this.editInfo, obj)
        } else {
          this.sameAs = ''
          this.$refs.informationForm.resetFields()
        }
      },

      /*
      * @method { Function } sameAsConfig 使用已填写房间的信息
      * */
      sameAsConfig(room) {
        this.getSaveConfig(room)
      }
    },
    created() {
      if (!this.roomOrigin) {
        this.$router.push({path: '/reservation'});
      }
      this.getInfos('/api/junket/info/titles', 'titles', 'titles')
      this.getInfos('/api/junket/info/countries', 'countries', 'country')
      this.initData('room_1')
    },
    computed: {
      roomOrigin() {
        return this.$store.state.roomOrigin
      },
      roomSaveArr() {
        return Object.values(this.roomSave)
      },
      roomPubInfo() {
        return this.$store.state.roomSearch
      },
      roomQty() {
        return Object.keys(this.roomOrigin).length
      },
      roomKey() {
        return Object.entries(this.roomOrigin)[this.roomIndex - 1]
      }
    },
    watch: {
      roomQty(qty) {
        if (!qty) {
          this.$router.push({path: '/reservation'});
        }
      }
    },
  }

</script>

